import React from "react";
import { Link } from "react-router-dom";


const MenuBar = () => {
  return (
    <div className="bg-[#DFFFB6] shadow-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          {/* Logo or Title */}
          <h1 className="text-2xl font-bold text-[#61C0BF]">EDL Tool</h1>

          {/* Navigation Links */}
          <nav>
            <ul className="flex space-x-6 text-[#61C0BF] font-medium">
              <li className="hover:underline">
                <a href="/">Home</a>
              </li>
              <li className="hover:underline">
                <a href="/login">Login</a>
              </li>
              <li className="hover:underline">
                <a href="/about">About</a>
              </li>
              <li className="hover:underline">
              <Link to="/donate">Donate</Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  ); 
};

export default MenuBar;
